import AddWords from "../../components/AddWords";
import { useNavigate } from "react-router-dom";
import '../../styles/ProjectDetails.css';
import { Link } from 'react-router-dom';
import { useProject } from "../../hooks/useProject";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import ProjectNavbar from "../../components/common/ProjectNavbar/ProjectNavbar";

export default function OfflineAddWords(){
    const {project, updateProject, index} = useProject();
    const navigate = useNavigate();

    return (
            <div>
                <ProjectHeader
                headerTitle = {project.title}
                showBackButton = {true}
                path={`/offline/project/${index}`}/>

                <AddWords 
                project={project}
                updateProject={updateProject}/>
                
                <ProjectNavbar
                projectIndex={index}
                />
   
            </div>
    )
}